import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { pageNames } from '@common/routes/pageNames';
import { useUser } from '@common/hooks/useUser';
import {
  IconHome,
  IconCreditCard,
  IconHelpCircle,
  IconLayers,
  IconNegotiation,
  IconUser,
  IconVelocimeter,
  IconLock,
} from '@consumidor-positivo/aurora';
import isDesktop from '@libs/utils/helpers/isDesktop';
import { CustomExperienceService } from '@libs/renegkit';

import useAuthenticatedUser from '@libs/acp/hooks/useAuthenticatedUser';

export const usePrivatePagesStates = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUser();
  const [reminders, setReminders] = useState<Record<string, any>[]>([]);
  const [remindersLength, setRemindersLength] = useState(0);
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);

  const isOnRenegOnlyExperience = CustomExperienceService.getLeadsCustomExperience();

	const { tokenOrigin } = useAuthenticatedUser();

	const isSimplified = tokenOrigin() === 'simplified';

  const dataSourceNavbar = [
    {
      name: 'Início',
      onClick: () => navigate(pageNames.myDebts.path),
      active: location.pathname === pageNames.myDebts.path,
    },
    {
      name: 'Dívidas',
      Icon: <IconNegotiation />,
      dropdown: [
        {
          name: 'Minhas dívidas',
          onClick: () => navigate(pageNames.debts.path),
          active: location.pathname === pageNames.debts.path,
          hideDesktop: true,
          hideOnRenegOnly: true,
        },
        {
          name: 'Dívidas negativadas',
          onClick: () => navigate(pageNames.negativeDebts.path),
          active: location.pathname === pageNames.negativeDebts.path,
          hideDesktop: true,
          hideOnRenegOnly: true,
        },
      ],
    },
    {
      name: 'Meus acordos',
      onClick: () => navigate(pageNames.RKMyAgreements.path),
      active: location.pathname === pageNames.RKMyAgreements.path,
    },
    {
      name: 'Crédito',
      onClick: () => navigate(pageNames.offers.path),
      active: location.pathname === pageNames.offers.path,
      hideOnRenegOnly: true,
    },
    {
      name: 'Score e Meu CPF',
      onClick: () => navigate(pageNames.myScore.path),
      active: location.pathname === pageNames.myScore.path || location.pathname === pageNames.scoreKbaQuestions.path,
      hideOnRenegOnly: true,
    },
  ].filter((i) => !(isOnRenegOnlyExperience && i.hideOnRenegOnly));

  const dataSourceNavbarVertical = [
    {
      name: 'Início',
      onClick: () => navigate(pageNames.myDebts.path),
      active: location.pathname === pageNames.myDebts.path,
      Icon: <IconHome />,
      hideDesktop: true,
    },
    {
      name: 'Dívidas',
      Icon: <IconNegotiation />,
      dropdown: [
        {
          name: 'Minhas dívidas',
          onClick: () => navigate(pageNames.debts.path),
          active: location.pathname === pageNames.debts.path,
          hideDesktop: true,
          hideOnRenegOnly: true,
        },
        {
          name: 'Dívidas negativadas',
          onClick: () => navigate(pageNames.negativeDebts.path),
          active: location.pathname === pageNames.negativeDebts.path,
          hideDesktop: true,
          hideOnRenegOnly: true,
        },
      ],
    },
    {
      name: 'Meus acordos',
      onClick: () => navigate(pageNames.RKMyAgreements.path),
      active: location.pathname === pageNames.RKMyAgreements.path,
      Icon: <IconLayers />,
      hideDesktop: true,
    },
    {
      name: 'Crédito',
      onClick: () => navigate(pageNames.offers.path),
      active: location.pathname === pageNames.offers.path,
      Icon: <IconCreditCard />,
      hideDesktop: true,
      hideOnRenegOnly: true,
    },
    {
      name: 'Score e Meu CPF',
      onClick: () => navigate(pageNames.myScore.path),
      active: location.pathname === pageNames.myScore.path || location.pathname === pageNames.scoreKbaQuestions.path,
      Icon: <IconVelocimeter />,
      hideDesktop: true,
      hideOnRenegOnly: true,
    },
    {
      name: 'Minha conta',
      onClick: () => navigate(pageNames.account.path),
      Icon: <IconUser />,
      active: location.pathname === pageNames.account.path,
			hideOnAuthSimplified: true
    },
    {
      name: 'Alterar senha',
      onClick: () => navigate(pageNames.updatePasswordACP.path),
      Icon: <IconLock />,
      active: location.pathname === pageNames.updatePasswordACP.path,
			hideOnAuthSimplified: true
    },
    {
      name: 'Central de ajuda',
      onClick: () => window.open('https://www.acordocerto.com.br/central-de-ajuda'),
      active: false,
      Icon: <IconHelpCircle />,
    },
  ]
    .filter((i) => !(isDesktop() && i.hideDesktop))
    .filter((i) => !(isOnRenegOnlyExperience && i.hideOnRenegOnly))
		.filter((i) => !(isSimplified && i.hideOnAuthSimplified));

  return {
    dataSourceNavbar,
    dataSourceNavbarVertical,
    reminders,
    setReminders,
    remindersLength,
    setRemindersLength,
    user,
    location,
    showLogoutModal,
    setShowLogoutModal,
  };
};
